import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grievance-redressal-committee',
  templateUrl: './grievance-redressal-committee.component.html',
  styleUrls: ['./grievance-redressal-committee.component.scss']
})
export class GrievanceRedressalCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
